import AbstractProvidedClass from "../../../shared/AbstractProvidedClass";

export default class MassReorderAction extends AbstractProvidedClass {
    constructor(provider, selectedElements, operation) {
        super(provider);

        this.oldOrder = [...this.elements.collection];

        let selectedSet = new Set(selectedElements);
        let sortedIndices = selectedElements
            .map(el => this.elements.indexOf(el))
            .sort((a, b) => a - b);
        let sortedSelected = sortedIndices.map(i => this.elements.collection[i]);
        let remaining = this.elements.collection.filter(el => !selectedSet.has(el));

        this.newOrder = null;

        switch (operation) {
            case 'front':
                this.newOrder = [...remaining, ...sortedSelected];
                break;
            case 'back':
                this.newOrder = [...sortedSelected, ...remaining];
                break;
            case 'forward': {
                let maxIdx = Math.max(...sortedIndices);
                let targetIdx = maxIdx + 1;
                while (targetIdx < this.oldOrder.length && selectedSet.has(this.oldOrder[targetIdx])) {
                    targetIdx++;
                }
                if (targetIdx < this.oldOrder.length) {
                    let jumpOver = this.oldOrder[targetIdx];
                    let insertPos = remaining.indexOf(jumpOver) + 1;
                    this.newOrder = [...remaining.slice(0, insertPos), ...sortedSelected, ...remaining.slice(insertPos)];
                }
                break;
            }
            case 'backward': {
                let minIdx = Math.min(...sortedIndices);
                let targetIdx = minIdx - 1;
                while (targetIdx >= 0 && selectedSet.has(this.oldOrder[targetIdx])) {
                    targetIdx--;
                }
                if (targetIdx >= 0) {
                    let jumpOver = this.oldOrder[targetIdx];
                    let insertPos = remaining.indexOf(jumpOver);
                    this.newOrder = [...remaining.slice(0, insertPos), ...sortedSelected, ...remaining.slice(insertPos)];
                }
                break;
            }
        }
    }

    finish() {
        if (!this.newOrder) {
            this.actions.discard();
            return;
        }
        this.elements.collection = this.newOrder;
        this.actions.finish();
    }

    undo() {
        this.elements.collection = [...this.oldOrder];
    }

    redo() {
        this.elements.collection = [...this.newOrder];
    }
}
